import { TenantEntity } from '../TenantEntity'

export class QuotationLclDetail extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'QuotationLclDetail'
  }

  get level() {
    return this._data.level
  }
  set level(level) {
    this._data.level = level || 0
  }
  get pol() {
    return this._data.pol
  }
  set pol(pol) {
    this._data.pol = pol
  }
  get pod() {
    return this._data.pod
  }
  set pod(pod) {
    this._data.pod = pod
  }
  get via() {
    return this._data.via
  }
  set via(via) {
    this._data.via = via
  }
  get source() {
    return this._data.source
  }
  set source(source) {
    this._data.source = source || 0
  }
  get term() {
    return this._data.term
  }
  set term(term) {
    this._data.term = term
  }
  get carrier() {
    return this._data.carrier
  }
  set carrier(carrier) {
    this._data.carrier = carrier || 0
  }
  get shippingLine() {
    return this._data.shippingLine
  }
  set shippingLine(shippingLine) {
    this._data.shippingLine = shippingLine
  }
  get departureDay() {
    return this._data.departureDay
  }
  set departureDay(departureDay) {
    this._data.departureDay = departureDay
  }
  get closingDay() {
    return this._data.closingDay
  }
  set closingDay(closingDay) {
    this._data.closingDay = closingDay
  }
  get days() {
    return this._data.days
  }
  set days(days) {
    this._data.days = days
  }
  get currency() {
    return this._data.currency
  }
  set currency(currency) {
    this._data.currency = currency
  }
  get weightPrice() {
    return this._data.weightPrice
  }
  set weightPrice(weightPrice) {
    this._data.weightPrice = weightPrice || 0
  }
  get volumePrice() {
    return this._data.volumePrice
  }
  set volumePrice(volumePrice) {
    this._data.volumePrice = volumePrice || 0
  }
  get beginDate() {
    return this._data.beginDate
  }
  set beginDate(beginDate) {
    this._data.beginDate = beginDate
  }
  get endDate() {
    return this._data.endDate
  }
  set endDate(endDate) {
    this._data.endDate = endDate
  }
  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks
  }
  get weightCost() {
    return this._data.weightCost
  }
  set weightCost(weightCost) {
    this._data.weightCost = weightCost || 0
  }
  get volumeCost() {
    return this._data.volumeCost
  }
  set volumeCost(volumeCost) {
    this._data.volumeCost = volumeCost || 0
  }
  get quotationUuid() {
    return this._data.quotationUuid
  }
  set quotationUuid(quotationUuid) {
    this._data.quotationUuid = quotationUuid
  }

  /* =============扩展属性================= */
  // 拼箱报价价格明细和运价
  get priceLcl() {
    return this._data.priceLcl
  }
  set priceLcl(priceLcl) {
    this._data.priceLcl = priceLcl
  }
}
